import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getConsent, setConsent, onOpenCookieBanner } from "@/lib/consent";

const CookieBanner = () => {
  const [open, setOpen] = useState(() => !getConsent());

  useEffect(() => onOpenCookieBanner(() => setOpen(true)), []);

  if (!open) return null;

  const choose = (value) => {
    setOpen(false);
    setConsent(value);
  };

  return (
    <div
      role="dialog"
      aria-label="Consenso cookie"
      data-testid="cookie-banner"
      className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-3xl rounded-xl border border-white/15 bg-surface/95 p-5 text-sm text-white/75 shadow-2xl backdrop-blur-xl md:p-6"
    >
      <p className="leading-relaxed">
        Usiamo cookie tecnici necessari al funzionamento del sito e, solo con il tuo consenso, cookie statistici
        (PostHog) per capire come viene utilizzato il sito. Puoi cambiare scelta in qualsiasi momento da "Preferenze
        cookie" in fondo alla pagina. Dettagli nella{" "}
        <Link to="/cookie-policy" data-testid="cookie-banner-policy-link" className="text-brand underline">
          Cookie Policy
        </Link>
        .
      </p>
      <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:justify-end">
        <button
          type="button"
          onClick={() => choose("denied")}
          data-testid="cookie-reject-button"
          className="rounded-md border border-white/20 px-6 py-3 text-xs font-semibold uppercase tracking-[0.15em] text-white transition-colors hover:border-white/50"
        >
          Rifiuta
        </button>
        <button
          type="button"
          onClick={() => choose("granted")}
          data-testid="cookie-accept-button"
          className="rounded-md bg-brand px-6 py-3 text-xs font-semibold uppercase tracking-[0.15em] text-white transition-colors hover:bg-brand-hover"
        >
          Accetta
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
